<details>
  <summary (click)="openDetails(content)">
    <img width="30px" [src]="getToolIcon(content.tool)" />
    <h6 class="px-4 link">{{ content.tool }}</h6>
    <span class="badge">{{ content.goal }}</span>
    <span *ngFor="let category of content.deployment_requirements.categories">
      <span class="badge">{{ getReadableCategory(category) }}</span>
    </span>
  </summary>
  <div class="content">
    <kendo-tabstrip>
      <kendo-tabstrip-tab title="Queries" [selected]="true">
        <ng-template kendoTabContent>
          <div class="py-3" *ngIf="generatedContentDetails">
            <div *ngFor="let detail of generatedContentDetails.content">
              <h1 class="title">{{ content.title }}</h1>
              <strong class="label"
                >{{ generatedContentDetails.tool | uppercase }} -
                {{ getReadableCategory(detail.category) | uppercase }}</strong
              ><i
                style="cursor: pointer"
                class="k-icon k-font-icon k-i-copy"
                (click)="onCopy($event.target)"
              ></i>
              <pre>{{ detail.query }}</pre>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab
        *ngIf="generatedAddtionalContentDetails.length > 0"
        title="Additional Queries"
      >
        <ng-template kendoTabContent>
          <div
            class="py-3"
            *ngFor="
              let detail of generatedAddtionalContentDetails;
              let last = last
            "
          >
            <div *ngFor="let query of detail.content">
              <h1 class="title">{{ content.title }}</h1>
              <strong
                >{{ detail.tool | uppercase }}
                -
                {{ query.category | uppercase }}</strong
              ><i
                style="cursor: pointer"
                class="k-icon k-font-icon k-i-copy"
                (click)="onCopy($event.target)"
              ></i>
              <pre>{{ query.query }}</pre>
            </div>
            <hr *ngIf="!last" />
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab
        *ngIf="
          contentDetails?.deployment_requirements.categories?.length ||
          contentDetails?.deployment_requirements.searchable_data?.length
        "
        title="Deployment Requirements"
      >
        <ng-template kendoTabContent>
          <div class="py-3">
            <div
              *ngIf="contentDetails?.deployment_requirements.categories?.length"
            ></div>
            <div
              *ngIf="
                contentDetails?.deployment_requirements.searchable_data?.length
              "
            >
              <strong class="label">Searchable Data</strong>
              <p>
                {{
                  contentDetails?.deployment_requirements.searchable_data.join(
                    ', '
                  )
                }}
              </p>
            </div>
            <div
              *ngIf="
                contentDetails?.deployment_requirements.deployment_steps?.length
              "
            >
              <strong class="label">Deployment Steps</strong>
              <cyborg-markdown
                [md]="contentDetails?.deployment_requirements.deployment_steps"
              ></cyborg-markdown>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </div>
</details>
